// Module
var code = "<tr> <td colspan=\"3\" class=\"table-sub-head\"> <!--ko if: ManipulationsEnabled--> <button type=\"button\" class=\"btn btn-sm btn-primary\" data-bind=\"click: OnDataRoleAdding.bind($data)\"> <i class=\"fa fa-plus\"></i> </button> <!--/ko--> <span data-bind=\"text: _dataRole.Name\"></span> </td> </tr>";
// Exports
export default code;